import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Icons } from '@nxsys/types/icons';
import { DraftPayroll } from '@nxsys/types/models/payroll';
import { Tooltip, Tag } from 'antd';

type Props = {
  record: DraftPayroll;
  onDownload: (id: string) => void;
  onConfirm: (id: string) => void;
  onDelete: (id: string) => void;
};

const DraftPayrollActionCell: React.FC<Props> = ({
  record,
  onDownload,
  onConfirm,
  onDelete,
}) => {
  const { messages } = useTypedIntl();

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        gap: 8,
        alignItems: 'center',
      }}
    >
      <Tooltip title={messages['common.download']}>
        <span
          className="cursor-pointer"
          onClick={() => onDownload(record.selfBillRef?.id)}
        >
          <Icons.IconDownload />
        </span>
      </Tooltip>
      <Tooltip title={messages['common.confirm']}>
        <span className="cursor-pointer" onClick={() => onConfirm(record.id)}>
          <Icons.IconCheck color="#00795B" />
        </span>
      </Tooltip>
      <Tooltip title={messages['common.delete']}>
        <span className="cursor-pointer" onClick={() => onDelete(record.id)}>
          <Icons.IconTrash color="red" />
        </span>
      </Tooltip>
      {record?.isPAL && (
        <span>
          <Tag color="warning" className="ml-1">
            PAL
          </Tag>
        </span>
      )}
    </div>
  );
};

export default DraftPayrollActionCell;
